import * as THEOS from "../interfaces/theos.interface";
import { LogLevel, error, log, setLogLevel } from "../utils/log";
import { getConfiguration, isTargetOriginReceived } from "./configuration";
import { IModuleConfig } from "./types";
import { LegacyApiAdapter } from "../modules/LegacyApiAdapter";
import { RgPostMessageApiAdapter } from "../modules/RgPostMessageApiAdapter";
import { TheosApi } from "../modules/TheosApi";
import { addSupportedApi } from "./messageProcessor";
import { processInboundMessageBuffer } from "./messageBuffer";
import { sendGameEvent } from "./sendGameEvent";

let apexApiCreated = false;
let rgApisCreated = false;

/**
 * @internal
 * Sends some configuration data to the possible Theos layer
 */
const configureApi = (newConfig: IModuleConfig): void =>
{
    log("Assigning config:", LogLevel.INIT, Object.keys(newConfig));
    log("Config content:", LogLevel.ALL_MESSAGES_AND_PAYLOADS, newConfig);

    const config = getConfiguration();
    Object.assign(config, newConfig);

    if (!rgApisCreated && config.handleRgPostMessageAPI === true && isTargetOriginReceived()) {
        rgApisCreated = true;
        addSupportedApi(new RgPostMessageApiAdapter());
        addSupportedApi(new LegacyApiAdapter());
    }

    // APEX handshake is attempted once we get either clientConfig or p2pConfig, as they can contain targetOrigin
    if (!apexApiCreated && isTargetOriginReceived()) {
        apexApiCreated = true;
        addSupportedApi(new TheosApi());
        processInboundMessageBuffer();
    }

    const {loginResponse} = newConfig;

    try {
        if (loginResponse !== undefined)
        {
            const configureData: THEOS.IConfigData = { currencyCode: loginResponse.stats.currency, specialSessionConfig: loginResponse.specialSessionConfig };
            sendGameEvent(THEOS.GameEvent.CONFIGURE, configureData);
        }
    } catch (e) {
        error("Invalid login response");
    }

    if (newConfig.p2pConfig !== undefined) {
        const configureData: THEOS.IConfigData = { currencyCode: newConfig.p2pConfig.currency, specialSessionConfig: newConfig.p2pConfig.specialSessionConfig };
        sendGameEvent(THEOS.GameEvent.CONFIGURE, configureData);
    }

    if (newConfig.handleFeaturePause) {
        sendGameEvent(THEOS.GameEvent.CONFIGURE, { handleFeaturePause: newConfig.handleFeaturePause });
    }
};

/**
 * Configures the module.
 *
 * Can be called multiple times, new configuration is merged into the existing one.
 *
 * @param config - An object containing the configuration changes
 */
export const configure = (config: IModuleConfig): void =>
{
    setLogLevel(config.logLevel);

    configureApi(config);
};